import React from "react";
import { BookOpenCheck, HelpCircle } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { Button } from "@/components/ui/button";
import useGlobalStore from "@/stores/useGlobalStore";

function SuggestionButton() {
  const toggleSuggestionPanel = useGlobalStore((state) => state.toggleSuggestionPanel);
  const showSuggestionPanel = useGlobalStore((state) => state.showSuggestionPanel);

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button variant="outline" size="sm" className={`rounded-lg font-normal mr-2 px-3`} onClick={toggleSuggestionPanel}>
            <BookOpenCheck className={`h-5 w-5`} />
            <p>Gợi ý</p>
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>{showSuggestionPanel ? "Ẩn gợi ý" : "Gợi ý mẫu câu hỏi"}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

export default SuggestionButton;
